import React, { useState } from 'react';
import { useI18n, useSelector } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import HandySettingsBlock from '~Scenes/Handy/Components/HandySettingsBlock';
import { Languages } from '~Types';

const LanguageSettings = () => {
  const locale = useSelector((state) => state.locale);
  const i18n = useI18n();

  const handleChangeLanguage = (locale: Languages) => {
    i18n.changeLanguage(locale);
  };

  const languageOptions = [
    {
      id: 'en',
      title: 'English',
    },
    {
      id: 'es',
      title: 'Spanish',
    },
    {
      id: 'se',
      title: 'Swedish',
    },
    {
      id: 'no',
      title: 'Norwegian',
    },
    {
      id: 'dk',
      title: 'Danish',
    },
    {
      id: 'tr',
      title: 'Turkish',
    },
  ];

  return (
    <HandyPageWrapper pageTitle={i18n.i18n('Settings.SelectLanguage')}>
      <HandySettingsBlock
        items={languageOptions.map((language) => ({
          id: language.id,
          title: `${i18n.i18n(language.title)} ${
            locale === language.id ? `(${i18n.i18n('Handy.Active')})` : ''
          }`,
          action: {
            onClick() {
              handleChangeLanguage(language.id as Languages);
            },
          },
        }))}
      />
    </HandyPageWrapper>
  );
};

export default LanguageSettings;
